import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import hoistNonReactStatics from 'hoist-non-react-statics';
import {
  commandIamSubscriptionUserList,
} from 'containers/ConnectionManager/actions';
import { selectSubscriptionAccountList } from 'domains/subscription/selectors';
import { AccountShape } from 'domains/subscription/shapes';

/**
 * Provides a list user "Subscriptions" to the wrapped component, along with a function
 * to trigger a refetch.
 * @param {React.Component} Component to wrap.
 */
export default (Component) => {
  class EnhancedComponent extends React.Component {
    static displayName = `EnhancedWithSubscription(${Component.displayName || Component.name || 'Component'})`;

    static propTypes = {
      subscriptionAccountList: PropTypes.arrayOf(AccountShape),
      getSubscriptionUserList: PropTypes.func,
    };

    // fetch on mount…
    UNSAFE_componentWillMount() {
      this.props.getSubscriptionUserList();
    }

    render() {
      const {
        subscriptionAccountList,
        ...props
      } = this.props;

      if (subscriptionAccountList) {
        return (<Component {...props} subscriptionAccountList={subscriptionAccountList} />);
      }

      return <div></div>;
    }
  }

  const mapStateToProps = (state) => ({
    subscriptionAccountList: selectSubscriptionAccountList(state),
  });

  const mapDispatchToProps = (dispatch) => ({
    getSubscriptionUserList: () => dispatch(commandIamSubscriptionUserList()),
  });

  const connectedComponent = connect(mapStateToProps, mapDispatchToProps)(EnhancedComponent);
  return hoistNonReactStatics(connectedComponent, Component);
};

